import axios from 'axios';
import {descriviErrore} from './vetrinaApi';
import {lingua} from '../preferenze';

/**
 * LA REGISTRAZIONE ONLINE: le chiamate a user-management.
 *
 * COSA FA: manda la richiesta di registrazione col DOMINIO da cui il sito e'
 * aperto (e' cosi' che user-management sa la skin, e la skin decide canali,
 * dati e durata del gettone); conferma col codice corto (SMS); rimanda la
 * conferma. COSA NON FA: non decide niente lato client - cosa e' obbligatorio
 * lo dice la skin (skin.registrazione), e lo ricontrolla il servizio.
 */
function base() {
  const env = (typeof window !== 'undefined' && window.env) || {};
  return env.REACT_APP_API_URL || '';
}

function intestazioni() {
  const env = (typeof window !== 'undefined' && window.env) || {};
  const h = {'Content-Type': 'application/json', 'X-Client-Surface': 'FRONTEND'};
  // l'intestazione numerica vecchia: user-management la pretende ancora
  h.TENANT_ID = env.REACT_APP_API_TENANT || '1';
  return h;
}

export function dominioCorrente() {
  return typeof window !== 'undefined' ? window.location.hostname : '';
}

/**
 * Registra. Torna {userId, username} oppure lancia un Error con .codice e
 * .messaggio del servizio (es. 409 nome utente gia' usato, 400 manca il
 * telefono, 403 registrazione chiusa).
 */
export async function registra(dati) {
  const r = await axios.post(`${base()}/users-management-service/api/users/register`, {
    // la lingua in cui il sito e' aperto: con quella partono conferma e messaggi
    lingua: lingua(),
    ...dati,
    dominio: dominioCorrente(),
  }, {headers: intestazioni(), validateStatus: () => true});
  const corpo = r.data || {};
  const stato = Number(corpo.status || r.status);
  if (stato >= 200 && stato < 300 && corpo.user) {
    // «attivazione» viaggia accanto all'utente: subito, operatore, conferma
    return {...corpo.user, attivazione: corpo.attivazione || 'conferma'};
  }
  const e = new Error(corpo.message || `Errore ${stato}`);
  e.codice = stato;
  e.messaggio = corpo.message || descriviErrore({response: r});
  // il codice dell'errore (es. CODICE_INVITO_NON_VALIDO): la pagina lo mette sotto il campo giusto
  e.code = corpo.code || null;
  throw e;
}

/**
 * Cosa dice la piattaforma di un codice invito, prima di registrare: {valido,
 * invitante} oppure {valido: false, code, message} se la Struttura non
 * risponde. Non lancia: un codice che non vale si scrive sotto il campo.
 */
export async function cercaInvito(codice) {
  const c = String(codice || '').trim().toUpperCase();
  if (!c) return {valido: false};
  const r = await axios.get(`${base()}/users-management-service/api/users/register/invito/${encodeURIComponent(c)}`,
      {headers: intestazioni(), validateStatus: () => true});
  const corpo = r.data || {};
  if (r.status >= 200 && r.status < 300) return corpo;
  return {valido: false, code: corpo.code || `HTTP_${r.status}`, message: corpo.message || `Errore ${r.status}`};
}

/** La conferma col codice corto ricevuto per SMS (o scritto a mano da Telegram). */
export async function confermaCodice(codice, skinId) {
  const r = await axios.post(`${base()}/users-management-service/api/users/register/conferma-codice`,
      {codice, skinId}, {headers: intestazioni(), validateStatus: () => true});
  const corpo = r.data || {};
  const stato = Number(corpo.status || r.status);
  if (stato >= 200 && stato < 300) return corpo.message || 'Conto attivato';
  const e = new Error(corpo.message || `Errore ${stato}`);
  e.codice = stato;
  e.messaggio = corpo.message || `Errore ${stato}`;
  throw e;
}

/** Rimanda la conferma (email, SMS o un codice nuovo per Telegram). */
export async function rimanda(email) {
  const r = await axios.post(`${base()}/users-management-service/api/users/register/email/resend`,
      {email}, {headers: intestazioni(), validateStatus: () => true});
  const corpo = r.data || {};
  const stato = Number(corpo.status || r.status);
  if (stato >= 200 && stato < 300) return corpo.message || 'Inviato';
  const e = new Error(corpo.message || `Errore ${stato}`);
  e.codice = stato;
  e.messaggio = corpo.message || `Errore ${stato}`;
  throw e;
}
